import { useState } from 'react';
import styles from './MeetingModal.module.scss';
import { ReactComponent as BlackBackIcon } from "assets/blackBack.svg";
import { ReactComponent as IdentificationCardIcon } from "assets/identificationCard.svg";
import { ReactComponent as NavigationArrowIcon } from "assets/navigationArrowRight.svg";
import { ReactComponent as CloseIcon } from "assets/close.svg";
import { ReactComponent as AlarmIcon } from "assets/alarm.svg";
import { ReactComponent as BlueAlarmIcon } from "assets/blueAlarm.svg";
import StartTimeModal from '../StartTimeModal';
import DurationModal from '../DurationModal';
import Button from "components/Button/Button";
import { store } from "stores/Store";
import useWindowSize from 'hooks/useWindowSize';

interface IMeetingModalProps {
  isOpen: boolean;
  practitioner: any;
  isDesktopMap?: boolean;
  onClose: () => void;
  onSelectPractitioner?: () => void;
  updatePractitioner: (practitionerId: number, updateData: any) => void;
  onDelete: () => void;
  setSelectedView: (view: string) => void;
  checkDuration: () => string;
  checkStartTime: () => string;
  setGoRouteModalIsOpen: (isOpen: boolean) => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const openGoogleMapsStreetView = (practitioner: any) => {
  const address = encodeURIComponent(practitioner.address || '');
  const coordinates = `${practitioner.latitude},${practitioner.longitude}`;
  const query = address || coordinates;
  window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, '_blank');
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MeetingModal = ({ isOpen, practitioner,isDesktopMap, onClose, updatePractitioner, onDelete, setSelectedView, checkDuration, checkStartTime, setGoRouteModalIsOpen,onSelectPractitioner }: IMeetingModalProps) => {
  const initialStartTime = checkStartTime();
  const initialDuration = checkDuration() ? checkDuration() : '15 min';
  const [startTime, setStartTime] = useState(initialStartTime);
  const [isStartTimeModalOpen, setIsStartTimeModalOpen] = useState(false);
  const [isDurationModalOpen, setIsDurationModalOpen] = useState(false);
  const [duration, setDuration] = useState<string>(initialDuration);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { width, height } = useWindowSize();
  const closeMeetingModal = () => {
    const minutes = duration.includes('min')
      ? parseInt(duration)
      : Math.round(parseFloat(duration) * 60);
    
    // Check if anything changed
    const initialMinutes = initialDuration.includes('min')
      ? parseInt(initialDuration)
      : Math.round(parseFloat(initialDuration) * 60);
    const hasChanges = startTime !== initialStartTime || minutes !== initialMinutes;
    onClose();
    console.log('startTime', startTime)
    console.log('minutes', minutes)
    updatePractitioner(practitioner.id, {
      start_time: startTime,
      meeting_duration: minutes,
      hasChanges: hasChanges
    });
    setStartTime('');
    setDuration('15 min');
  }

  const handleIdentificationCardClick = () => {
    store.setCurrentPractitioner(practitioner);
    onSelectPractitioner?.();
  }

  if (!isOpen || !practitioner) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modal}
        onClick={e => e.stopPropagation()} 
        style={{ borderRadius: isDesktopMap ? 0 : '40px 40px 0 0' }}
      >
        <div className={styles.modalContent}>
          <div className={styles.header}>
            <BlackBackIcon
              className={styles.backButton}
              onClick={closeMeetingModal}
              height={20}
              width={20}
              style={{
                position: 'absolute',
                left: 15,
                paddingRight: 10,
                top: 30
              }}

            />
            <div className={styles.practitionerInfo}>
              <div className={styles.practitionerInfoHeader}>
                <span className={styles.practitionerName}>{practitioner.name}</span>
                <span className={styles.practitionerSpecialty}>{practitioner.specialty}</span>
              </div>
              <IdentificationCardIcon onClick={handleIdentificationCardClick} style={{ cursor: 'pointer', marginRight: '7px' }} />
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.address}>
              {practitioner.address}
              {/*<div onClick={() => openGoogleMapsStreetView(practitioner)}><NavigationArrowIcon stroke={'#8B8B8B'} width={22} height={22} />Navigate</div>*/}
              <div className={styles.navigateButton} onClick={() => setGoRouteModalIsOpen(true)}>
                <NavigationArrowIcon stroke={'#4F7D9C'} width={22} height={22} />NAVIGATE
              </div>                            
            </div>
            <div className={styles.timeWrapper}>
              <div className={styles.timeHeader}>
                <span style={{ fontSize: 16 }}>
                  Start Time
                </span>
                <span className={styles.timeHeaderHelper}>
                  If you need to be at the location at this time
                </span>
              </div>
              <div>
                {startTime ? (
                  <div className={styles.time}>
                    <BlueAlarmIcon width={35} height={35} />
                    <span onClick={() => setIsStartTimeModalOpen(true)} style={{ fontSize: 30, color: "#4F7D9C" }}>{startTime}</span>
                    <CloseIcon style={{ marginLeft: 20 }} color="#4F7D9C" width={20} height={20} onClick={() => setStartTime('')} />
                  </div>
                ) : (
                  <div onClick={() => setIsStartTimeModalOpen(true)} className={styles.timeComponent}>
                    <AlarmIcon />
                    <span style={{ fontSize: 16, color: "#8B8B8B" }} >No time set</span>
                  </div>
                )}
                <StartTimeModal
                  isOpen={isStartTimeModalOpen}
                  onClose={() => setIsStartTimeModalOpen(false)}
                  startTime={startTime}
                  setStartTime={setStartTime}
                  setIsStartTimeModalOpen={setIsStartTimeModalOpen}
                />
              </div>
            </div>
            <span style={{ paddingLeft: 10, fontSize: 16 }}>
              Meeting Duration
            </span>
            <div className={styles.duration}>
              <div onClick={() => setIsDurationModalOpen(true)} className={styles.timeComponent}>
                <span style={{ fontSize: 30 }}>
                  {duration.includes('min')
                    ? duration.split(' ')[0]
                    : Number(duration.split(' ')[0]).toString()}
                </span>
                <span style={{ fontSize: 18 }}>
                  {duration.includes('min') ? 'Minutes' : parseFloat(duration) === 1.0 ? 'Hour' : 'Hours'}
                </span>
              </div>
              <DurationModal
                isOpen={isDurationModalOpen}
                onClose={() => {
                  setIsDurationModalOpen(false);
                }}
                duration={duration}
                setDuration={setDuration}
                setIsDurationModalOpen={setIsDurationModalOpen}
              />
            </div>
            <div className={styles.buttonContainer}>
              <Button fontSize={20} fontWeight="700" width="100%" type="outline" color="#E64B3780" textColor="#E64B37" onClick={onDelete}>DELETE MEETING</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingModal;
